import { DocumentModel } from "@app/shared/cerrix-documents/models/document.model";

export abstract class AbstractDocumentModel implements DocumentModel {
    id?: string;
    name: string;
    description?: string;
    documentId?: string;
    documentTypeId?: string;
    createdOn?: string;
    modifiedOn?: string;
    uploadedBy?: string;
    file?: File;
    fileSize?: string;
    fileIcon?: string;

    constructor() {
        this.name = "";
    }
}
